export default __webpack_public_path__ + "static/media/carpenter.d39a9f4f.svg";